import React, { useState, useEffect } from "react";
import { putCliente as modifCliente } from "../helpers/rutaClientes";
import { Modal, Button } from "react-bootstrap";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { getRutas } from "../helpers/rutaRutas";
import 'animate.css';

const ModalFormCliente = ({ cliente, handleClose, show }) => {
  const [formValues, setFormValues] = useState({
    codcli: "",
    razonsocial: "",
    domicilio: "",
    telefono: "",
    cuit: "",
    email: "",
    localidad: "",
    contacto1: "",  
    telefono1: "",
    email1: "",
    contacto2: "",  
    telefono2: "",
    email2: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
    if (cliente && cliente._id) {
      setFormValues({
        codcli: cliente.codcli || "",
        razonsocial: cliente.razonsocial || "",
        domicilio: cliente.domicilio || "",
        telefono: cliente.telefono || "",
        cuit: cliente.cuit || "",
        email: cliente.email || "",
        localidad: cliente.localidad?._id || "",
        contacto1: cliente.contacto1 || "",
        telefono1: cliente.telefono1 || "",
        email1: cliente.email1 || "",
        contacto2: cliente.contacto2 || "",
        telefono2: cliente.telefono2 || "",
        email2: cliente.email2 || "",
      });
    }
  }, [cliente]);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await modifCliente(cliente._id, formValues);
      console.log("✅ Cliente actualizado:", resp);

      setShowSuccess(true); // Mostrar el modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultarlo después de 2 segundos
        handleClose();         // Cerrar el modal principal
      }, 2000);
    } catch (error) {
      console.error("❌ Error al actualizar cliente:", error);
      // Si querés, podés mostrar un modal de error también acá
    }
  };


  const [localidades, setLocalidades] = useState({ data: {}, loading: true });
  const [rutas, setRutas] = useState({ data: {}, loading: true });

  useEffect(() => {
    getLocalidades().then((res) =>
      setLocalidades({ data: res, loading: false })
    );
    getRutas().then((res) => setRutas({ data: res, loading: false }));
  }, []);

  return (
    <>
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Cliente</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group mt-2">
            <label>Razón Social</label>
            <input
              type="text"
              className="form-control"
              name="razonsocial"
              required
              value={formValues.razonsocial}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Domicilio</label>
            <input
              type="text"
              className="form-control"
              name="domicilio"
              required
              value={formValues.domicilio}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Teléfono</label>
            <input
              type="text"
              className="form-control"
              name="telefono"
              required
              value={formValues.telefono}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>CUIT</label>
            <input
              type="text"
              className="form-control"
              name="cuit"
              required
              value={formValues.cuit}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              required
              value={formValues.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Localidad</label>
            <select
              className="form-control"
              name="localidad"
              value={formValues.localidad}
              onChange={handleChange}
              required
            >
              <option value="">Elija una opción</option>
              {localidades.data.localidades &&
                localidades.data.localidades.map((loc) => (
                  <option key={loc._id} value={loc._id}>
                    {loc.localidad}
                  </option>
                ))}
            </select>
          </div>

          <div className="form-group mt-2">
            <label>Contacto 1</label>
            <input
              type="text"
              className="form-control"
              name="contacto1"
              value={formValues.contacto1}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Teléfono Contacto 1</label>
            <input
              type="text"
              className="form-control"
              name="telefono1"
              value={formValues.telefono1}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Email Contacto 1</label>
            <input
              type="email"
              className="form-control"
              name="email1"
              value={formValues.email1}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Contacto 2</label>
            <input
              type="text"
              className="form-control"
              name="contacto2"
              value={formValues.contacto2}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Teléfono Contacto 2</label>
            <input
              type="text"
              className="form-control"
              name="telefono2"
              value={formValues.telefono2}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-2">
            <label>Email Contacto 2</label>
            <input
              type="email"
              className="form-control"
              name="email2"
              value={formValues.email2}
              onChange={handleChange}
            />
          </div>

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>

    <Modal
      show={showSuccess}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="animate__animated animate__fadeInDown"
      >
      <Modal.Body className="text-center">
        <div style={{ fontSize: "3rem" }}>🖐</div>
        <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
      </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormCliente;
